exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".launchpack-order td[data-v-54ee5cc4]{border:1px solid #dbdbdb}", ""]);

// exports
